module.exports = __webpack_public_path__ + "static/media/Internet AddictionActive.c71d8ae4.svg";